import React, { useState, useEffect, useRef } from "react";

function App() {
  const [file, setFile] = useState(null);
  const [filename, setFilename] = useState("");
  const [chat, setChat] = useState([]);
  const [question, setQuestion] = useState("");
  const [loading, setLoading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);

  const API_BASE = "https://api.inteliprop.ai:8443";
  const chatEndRef = useRef(null);

  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [chat]);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type === "application/pdf") {
      setFile(selectedFile);
      setFilename(selectedFile.name);
      setUploadSuccess(false);
    } else {
      alert("Por favor sube un archivo PDF válido.");
    }
  };

  const handleUpload = async () => {
    if (!file) return;

    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);

    await fetch(`${API_BASE}/upload`, {
      method: "POST",
      body: formData
    });

    setLoading(false);
    setUploadSuccess(true);
  };

  const handleAsk = async () => {
    if (!question.trim() || loading) return;

    const newChat = [...chat, { sender: "user", text: question }];
    setChat(newChat);
    setLoading(true);
    const res = await fetch(`${API_BASE}/ask`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ filename, question })
    });
    const data = await res.json();
    setChat([...newChat, { sender: "bot", text: String(data.answer) }]);
    setQuestion("");
    setLoading(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleAsk();
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-4 space-y-6">
      <div className="flex items-center space-x-4">
        <img src="/logo.png" alt="Logo" className="h-10" />
        <h1 className="text-xl font-bold text-primary">📄 Platica con tu informe ocupacional</h1>
      </div>

      <div className="bg-white rounded-xl shadow p-6">
        <input type="file" accept="application/pdf" onChange={handleFileChange} className="mb-2" />
        <button
          onClick={handleUpload}
          disabled={!file || loading}
          className="bg-blue-500 text-white px-4 py-2 rounded disabled:opacity-50"
        >
          Subir PDF
        </button>
        {loading && (
          <div className="mt-2 text-sm text-gray-500 flex items-center gap-2">
            <span className="loader animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-blue-500"></span>
            Procesando...
          </div>
        )}
        {uploadSuccess && (
          <div className="mt-2 text-green-600 text-sm">✅ Archivo cargado con éxito. Ya puedes hacer preguntas.</div>
        )}
      </div>

      <div className="bg-white rounded-xl shadow p-6">
        <div className="h-64 overflow-y-auto border rounded-xl p-3 bg-gray-50 mb-4">
          {chat.map((entry, idx) => (
            <div key={idx} className={`mb-2 text-sm ${entry.sender === "user" ? "text-right" : "text-left"}`}>
              <span
                className={`inline-block px-3 py-2 rounded-xl max-w-xs ${entry.sender === "user" ? "bg-blue-500 text-white" : "bg-gray-200 text-black"}`}
              >
                {String(entry.text)}
              </span>
            </div>
          ))}
          {loading && (
            <div className="text-sm text-gray-500 text-left">
              <span className="inline-block px-3 py-2 rounded-xl bg-gray-200 animate-pulse">
                Generando respuesta...
              </span>
            </div>
          )}
          <div ref={chatEndRef} />
        </div>
        <div className="flex gap-2">
          <textarea
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Escribe aquí tu pregunta"
            className="flex-grow border rounded px-3 py-2"
            disabled={loading}
          />
          <button
            onClick={handleAsk}
            disabled={!question || loading}
            className="bg-green-600 text-white px-4 py-2 rounded disabled:opacity-50"
          >
            Preguntar
          </button>
        </div>
      </div>
    </div>
  );
}

export default App;